// Matches the go-playground/validator format:
// "Key: 'Payload.Field' Error:Field validation for 'Field' failed on the 'min' tag"
const GO_VALIDATOR_RE =
  /Key: '[\w.]+' Error:Field validation for '\w+' failed on the '(\w+)' tag/;
const ORDER_LINE_TOTAL_LIMIT_RE =
  /^line total \d+(?:\.\d+)? exceeds maximum supported value \d+(?:\.\d+)?$/;

const VALIDATION_TAG_MESSAGES: Record<string, string> = {
  min: "Valor muito curto ou pequeno.",
  max: "Valor muito longo.",
  required: "Campo obrigatório não preenchido.",
  email: "Endereço de e-mail inválido.",
  len: "Comprimento inválido.",
  gt: "Valor muito pequeno.",
  gte: "Valor muito pequeno.",
  lt: "Valor muito grande.",
  lte: "Valor muito grande.",
};

/**
 * Converts a raw Go validator error message into a user-friendly Portuguese string.
 * Returns the original message unchanged if it does not match the validator format.
 */
export function sanitizeApiMessage(message: string): string {
  if (ORDER_LINE_TOTAL_LIMIT_RE.test(message)) {
    return "Quantidade muito alta para esse item. Diminua a quantidade e tente novamente.";
  }

  const match = GO_VALIDATOR_RE.exec(message);
  if (!match) return message;
  const tag = match[1] ?? "";
  return (
    VALIDATION_TAG_MESSAGES[tag] ??
    "Dado inválido. Verifique o campo e tente novamente."
  );
}
